import { useFeatureFlag } from "@/helpers/useFeatureFlag";
import { useBreadcrumb } from "@/components/breadcrumbs";
import { ExplorerContentOriginal } from "./ExplorerContentOriginal";
import { DiscoverContentV2 } from "./v2";

export const ExplorerContent = () => {
  useBreadcrumb("Discover");
  // V2 is the canonical /discover layout (Implemented Opportunities tab,
  // Priority tab, etc.). The original V1 layout is kept as an opt-OUT
  // safety net behind `useLegacyDiscoverPage` so QA/SE can flip back to
  // V1 via `?useLegacyDiscoverPage=true` if a V2 regression surfaces.
  //
  // Note: `useFeatureFlag` persists `=true` URL params into localStorage,
  // so once a tester opts into V1 they keep seeing V1 across subsequent
  // visits until they clear it (`?useLegacyDiscoverPage=false` removes
  // the entry). Acceptable for a rollback knob; documented for on-call.
  //
  // The legacy path is also what the V1-era unit tests render against,
  // so we don't break the suite while V2 tests are being authored.
  const legacyDiscoverEnabled = useFeatureFlag("useLegacyDiscoverPage");
  if (legacyDiscoverEnabled) {
    return <ExplorerContentOriginal />;
  }
  return <DiscoverContentV2 />;
};
